const DEFAULT_URL_BASE = 'https://t.me';
const URL_IN_TEXT_REGEX = /(https?:\/\/[^\s]+|t\.me\/[^\s]+)/gi;
const TELEGRAM_REF_LINK_REGEX = /(https?:\/\/)?t\.me\/patrickgamesbot[^\s]*/gi;
const REFERRAL_QUERY_PARAMS_TO_REMOVE = ['write_access', 'request_write_access'];

export function sanitizeReferralLink(value: unknown): string {
  if (typeof value !== 'string') {
    return '';
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return '';
  }

  try {
    const url = new URL(trimmedValue);
    REFERRAL_QUERY_PARAMS_TO_REMOVE.forEach(param => url.searchParams.delete(param));
    return url.toString();
  } catch {
    try {
      const url = new URL(trimmedValue, DEFAULT_URL_BASE);
      REFERRAL_QUERY_PARAMS_TO_REMOVE.forEach(param => url.searchParams.delete(param));
      return url.toString();
    } catch {
      let sanitizedValue = trimmedValue;

      for (const param of REFERRAL_QUERY_PARAMS_TO_REMOVE) {
        const regex = new RegExp(`([?&])${param}=[^&#]*(&?)`, 'gi');
        sanitizedValue = sanitizedValue.replace(regex, (_match, prefix: string, suffix: string) => {
          if (prefix === '?' && suffix) {
            return '?';
          }

          return prefix === '?' ? '' : suffix ? prefix : '';
        });
      }

      return sanitizedValue;
    }
  }
}

export function sanitizeReferralText(value: unknown): string {
  if (typeof value !== 'string') {
    return '';
  }

  return value.replace(URL_IN_TEXT_REGEX, match => sanitizeReferralLink(match) || match).trim();
}

export function injectReferralLinkIntoText(text: unknown, referralLink: unknown): string {
  const sanitizedText = sanitizeReferralText(text);
  const sanitizedReferralLink = sanitizeReferralLink(referralLink);

  if (!sanitizedReferralLink) {
    return sanitizedText;
  }

  if (!sanitizedText) {
    return sanitizedReferralLink;
  }

  if (sanitizedText.includes(sanitizedReferralLink)) {
    return sanitizedText;
  }

  const replacedTelegramLinkText = sanitizedText.replace(TELEGRAM_REF_LINK_REGEX, sanitizedReferralLink);
  if (replacedTelegramLinkText !== sanitizedText) {
    return replacedTelegramLinkText;
  }

  return `${sanitizedText}\n${sanitizedReferralLink}`;
}
